import { Route } from '@angular/router';
import { MultiSigningComponent } from './multisigning.component';

export const MultiSigningRoutes: Route[] = [
  {
    path: 'multisign/:code',
    component: MultiSigningComponent
  }
];
